/* eslint-disable @typescript-eslint/no-var-requires */
import {LocaleData, registerLocale} from "i18n-iso-countries";

const countriesEn: LocaleData = require('i18n-iso-countries/langs/en.json') as LocaleData;
const countriesDe: LocaleData = require('i18n-iso-countries/langs/de.json') as LocaleData;
const countriesFr: LocaleData = require('i18n-iso-countries/langs/fr.json') as LocaleData;
registerLocale(countriesEn);
registerLocale(countriesDe);
registerLocale(countriesFr);
